<template>
  <router-link class="work-item"
               :to="{ name: 'WorkDetail', params: { id: item.work.id } }"
  >
    <div class="work-info">
      <h4 class="work-title ym-two-line-ellipsis">{{ item.work.title }}</h4>
      <div class="work-user">
        <ym-avatar class="avatar"
                   :avatar="item.user.avatar"
                   :name="item.user.name"
                   lazy
                   size="small"
        />
        <div class="user-info">
          <div class="user-name ym-line-ellipsis">{{ item.user.name }}</div>
          <div class="user-summary">
            {{ item.user.age | formatUserAgeAndArea(item.user.area, ' ') }}
          </div>
        </div>
      </div>
    </div>
    <ym-img class="work-cover"
            :src="item.work.cover"
            :alt="item.work.title"
            lazy
    />
  </router-link>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'WorkItem',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .work-item {
    margin: 0 @size-base;
    padding: @size-base 0;
    background-color: @color-white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }

  .work-cover {
    display: block;
    width: 220px;
    height: 165px;
    flex-shrink: 0;
    margin-left: @size-small;
    border: @border-base;
    border-radius: @border-radius-base;
  }

  .work-info {
    flex: 1;
    overflow: hidden;
  }

  .work-title {
    margin: 0 0 @size-base;
    line-height: 1.4;
    font-weight: @font-weight-primary;
  }

  .work-user {
    display: flex;
  }

  .user-info {
    overflow: hidden;
    margin-left: @size-small;
    padding-top: @size-extra-small;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .user-name {
    font-size: @font-size-small;
  }

  .user-summary {
    font-size: @font-size-extra-small;
    color: @color-text-lighter;
  }
</style>
